import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { defineComponent, computed, toRefs, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import { ALL_CLIENT_APPLICATION_STATUS_FOR_REPORT, CLIENT_APPLICATION_STATUS_FOR_REPORT } from "@Shared/js/enum";
import { capitalize, flatMap } from "lodash";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "SelectApplicationStatus",
  components: {
    MaterialInput,
    vSelectField
  },
  props: {
    selectedApplicationStatus: {
      type: [String, Array],
      required: true,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    allApplicationStatus: {
      type: Boolean,
      default: false
    },
    statusToExclude: {
      type: Array,
      default: () => []
    },
    action: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    var _context;
    const {
      t,
      tc
    } = useI18n();
    const {
      selectedApplicationStatus,
      multiple,
      statusToExclude,
      action
    } = toRefs(props);
    const {
      handleSelectMultipleChange
    } = useMultipleSelect();
    const select = ref();
    const actionRef = ref(action);
    const statusMapToUse = computed(() => props.allApplicationStatus ? ALL_CLIENT_APPLICATION_STATUS_FOR_REPORT : CLIENT_APPLICATION_STATUS_FOR_REPORT);
    const applicationStatusOptions = ref([]);
    if (!_includesInstanceProperty(_context = statusToExclude.value).call(_context, "all")) applicationStatusOptions.value.push({
      id: "all",
      text: capitalize(tc("global.words.all", 1)).toString()
    });
    flatMap(statusMapToUse.value, (value, key) => {
      var _context2;
      if (!_includesInstanceProperty(_context2 = statusToExclude.value).call(_context2, value)) applicationStatusOptions.value.push({
        id: value,
        text: capitalize(t(`application.applicationStatus.${key}`).toString())
      });
    });
    const localSelectedApplicationStatus = computed({
      get() {
        var _selectedApplicationS;
        return (_selectedApplicationS = selectedApplicationStatus.value) != null ? _selectedApplicationS : multiple.value ? [] : "";
      },
      set(newValue) {
        emit("update:selectedApplicationStatus", newValue);
      }
    });
    const options = computed(() => ({
      placeholder: t("global.actions.chooseOption").toString(),
      closeOnSelect: !multiple.value
    }));
    const handleChange = (selectedValue, type) => {
      var _select$value;
      if (selectedValue.id === "all" && type === "select") (_select$value = select.value) == null ? void 0 : _select$value.close();
      localSelectedApplicationStatus.value = handleSelectMultipleChange(selectedValue, type, localSelectedApplicationStatus.value, multiple.value);
    };
    return {
      select,
      applicationStatusOptions,
      localSelectedApplicationStatus,
      options,
      actionRef,
      handleChange
    };
  }
});